import React from 'react'
import { ExpandMore as ExpandMoreBase, Help } from '@mui/icons-material'
import { Grid, styled } from '@mui/material'
import { Toast } from '@chilecompra/react-kit/components'

export const Anchor = styled('div')`
  border-bottom: 2px solid ${props => props.theme.palette.brand.black1};
  cursor: pointer;
  display: inline-flex;
  min-width: 60px;
`

export const AnchorText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0 16px 0 0;
  pointer-events: none;
  user-select: none;
`

export const AnchorIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black1};
    font-size: 24px;
    margin: 0 0 0 auto;
    pointer-events: none;
    transform: ${props => (props.open ? 'rotate(180deg)' : 'none')};
    user-select: none;
  }
`

export const BaseGrid = styled(({ margin, ...props }) => <Grid {...props} />)`
  &.MuiGrid-root {
    margin: ${props => props.margin};
  }
`

export const BoxDivider = styled(Grid)`
  &.MuiGrid-root {
    border-color: ${props => props.theme.palette.brand.gray2};
    border-width: 1px;
    border-right-style: solid;
  }
`
export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 24px;
  width: 100%;
`

export const ContentWrapper = styled(({ alignItems, alignSelf, children, flexDirection, justifyContent, ...props }) => (
  <div {...props}>{children}</div>
))`
  align-items: ${props => props.alignItems};
  align-self: ${props => props.alignSelf};
  display: ${props => props.display || 'flex'};
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const ExternalLink = styled('a')`
  align-content: baseline;
  color: ${props => props.theme.palette.blue[50]};
  display: flex;
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const HelpIcon = styled(Help)`
  color: ${props => props.theme.palette.blue[50]};
  font-size: 16px;
  padding-left: 8px;
`

export const LeftPanel = styled(({ padding, ...props }) => <Grid {...props} />)`
  &.MuiGrid-root {
    padding: ${props => props.padding};
  }
`

export const Link = styled('p')`
  align-content: baseline;
  font-size: 16px;
  color: ${props => props.theme.palette.gray[50]};
  display: flex;
  padding-top: 24px;
  text-decoration: underline;
  border: none;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.palette.gray[35]};
  }
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  overflow: visible;
  margin-bottom: 12px;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const SubHeadingWrapper = styled(({ alignItems, children, ...props }) => <div {...props}>{children}</div>)`
  align-items: ${props => props.alignItems};
  display: flex;
`

export const Toaster = styled(({ margin, ...props }) => <Toast {...props} />)`
  &.MuiAlert-root {
    margin: ${props => props.margin};
  }
`

export const VerticalSeparator = styled('hr')`
  background: ${props => props.theme.palette.custom.gray[75.5]};
  border: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: border-box;
  height: ${props => props.height};
  margin: auto 0;
  width: 2px;
`
